module.exports = __webpack_public_path__ + "img/Libya.90316638.png";